import { getVariantId } from "./variant.util";

interface UrlParameters {
  readonly AGE: string;
  readonly DAYS: string;
  readonly GENDER: string;
  readonly LOCATION: string;
  readonly CATEGORY: string;
  readonly STEP: string;
  readonly FULL_CLASSES: string;
  readonly USER: string;
  readonly CONTACT: string;
  readonly FUNNEL_SKIP: string;
  readonly SESSION: string;
}

export const API_REQUEST = ryb_connect_ajax.ajax_url;
export const RYB_CLASSES_DATA = (() => {
  const originalData = (typeof ryb_connect_classes_data !== "undefined" &&
    ryb_connect_classes_data) || { classes: [] };

  const variant_id = getVariantId();
  return {
    ...originalData,
    classes: originalData.classes.filter((item) => {
      return item.variant_id === variant_id;
    }),
  };
})();
export const RYB_WIZARD_PAGE = ryb_connect_wizard_page || "";
export const URL_PARAMETERS: UrlParameters = {
  AGE: "age",
  DAYS: "days",
  GENDER: "gender",
  LOCATION: "location",
  CATEGORY: "classtype",
  STEP: "step",
  FULL_CLASSES: "full-classes",
  USER: "user",
  CONTACT: "contact",
  FUNNEL_SKIP: "funnelskip",
  SESSION: "session",
};

/**
 * Whitelist of URL params the wizard/finder treats as filter inputs.
 * Anything outside this set (e.g. legacy Jackrabbit `Cat2=...` from
 * registration links, `utm_*` tracking params, or arbitrary share-link
 * keys) is ignored when filtering classes — without this guard, the
 * generic `filterByKeyAndValue` reducer would try to match the unknown
 * key against class fields, producing zero results.
 */
export const ALLOWED_FILTER_KEYS: ReadonlySet<string> = new Set([
  URL_PARAMETERS.AGE,
  URL_PARAMETERS.DAYS,
  URL_PARAMETERS.GENDER,
  URL_PARAMETERS.LOCATION,
  URL_PARAMETERS.CATEGORY,
  URL_PARAMETERS.FULL_CLASSES,
  URL_PARAMETERS.SESSION,
  // Legacy alias kept for backward compatibility with old saved-filter
  // cookies; gets migrated to CATEGORY when applied.
  "category",
]);
export const LOGIN_BUTTON_LINK =
  "https://app.jackrabbitclass.com/jr3.0/ParentPortal/Login";
